import useSWR from 'swr';
import { EngineService } from '@/services/engine';
import type { Person } from '@/types/person';
import { usePersonIdentityActions } from '@/features/IdentityActions';
import type { EntityActionModalsProps } from './types';
import { useOpenOnce } from './useOpenOnce';

export function PersonActionModals({
    entityId,
    actionKind,
    onClose,
    onChanged,
}: EntityActionModalsProps) {
    const { data: person, mutate } = useSWR<Person>(
        `person-${entityId}`,
        () => EngineService.getPerson(entityId),
        { revalidateOnFocus: false },
    );
    const { modals, openAction } = usePersonIdentityActions({
        person,
        includeDelete: false,
        mutateDetail: mutate,
        onChanged,
        onDeleted: onClose,
        onMerged: onClose,
        onSourceStale: onClose,
    });
    useOpenOnce(Boolean(person), async () => {
        await openAction(actionKind);
        if (actionKind === 'markAsUnknown') {
            onClose();
        }
    });

    return <>{modals}</>;
}
